import type { ButtonVariant } from '$global/components/Button';

export const getDropButtonVariant = (
	button: null | {
		secondary?: boolean | undefined | null;
	}
) => (button?.secondary ? 'secondary' : 'primary') as ButtonVariant;
